import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { IWizardStepContent } from "../../../../../wizard/types";
import PreviewProgram from "../../../components/step5/PreviewProgramHigher";
import { parseToCreateProgramPreview } from "../../../../helpers/parseToCreateProgramPreview";
import useMajorQueries from "../../../../../major/hooks/useMajorQueries";
import { useQuery } from "react-query";
import useBranchQueries from "../../../../../school/hooks/useBranchQueries";
import { useSchoolId } from "../../../../../school/hooks/useSchoolId";
import { QUERY_KEYS } from "../../../../../../constants";

const useStyles = makeStyles(() => ({
  mainContainer: {
    "& > div": {
      marginTop: 24,
    },
    "& > :first-child": {
      marginTop: "unset",
    },
  },
}));

const Content: FC<IWizardStepContent> = ({
  stepName,
  handleSubmit,
  ...formData
}) => {
  const classes = useStyles();

  const { branches: branchesQueryKey, majors: majorsQueryKey } = QUERY_KEYS;

  const { fetchAll: fetchAllMajors } = useMajorQueries();
  const { data: majors } = useQuery<any>(majorsQueryKey, fetchAllMajors, {
    staleTime: 600000,
  });

  const schoolId = useSchoolId();
  const { fetchAll: fetchAllBranches } = useBranchQueries();
  const { data: branches } = useQuery<any>(branchesQueryKey, () =>
    fetchAllBranches({ schoolId }),
  );

  if (!majors || !branches) {
    return null;
  }

  const previewData = parseToCreateProgramPreview({
    programRawData: formData.values,
    branches: branches.data,
  });

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div className={classes.mainContainer}>
        <PreviewProgram {...previewData} wizardMode={formData.values.mode} />
      </div>
    </form>
  );
};

export default Content;
